// src/routes/AllRoutes.tsx
//#region Imports
import { useEffect } from 'react';
import { Navigate, useLocation, useRoutes } from 'react-router-dom';
export { LoadComponent, type RouteObject } from './index';
import {
  DefaultLayout,
  VerticalLayout,
  HorizontalLayout,
  DetachedLayout,
  FullLayout,
} from 'layouts/index';
import {
  PrivateRouteAdmin,
  PrivateRouteAuthenticated,
  PrivateRouteEmployee,
  PrivateRouteTaxClaimant,
  PrivateRouteClient,
} from './Private/index';
import { LayoutTypes } from 'appConstants';
import { useRedux, useUser } from 'hooks';

import SystemRoutes from './System';
import AuthRoutes from './Auth';
import ScreenRoutes from './Screens/index';
import AdminRoutes from './Admin';
import UserProfile from './Profile';

import useAuth from 'global/Auth/use';
import { useNavigate } from 'react-router-dom';

//#region Rotas
const AllRoutes = () => {
  const { appSelector } = useRedux();

  // const { layout } = appSelector(state => ({ layout: state.Layout }));
  const layout = appSelector((state) => state.Layout);

  const getLayout = () => {
    switch (layout.layoutType) {
      case LayoutTypes.LAYOUT_HORIZONTAL:
        return HorizontalLayout;
      case LayoutTypes.LAYOUT_DETACHED:
        return DetachedLayout;
      case LayoutTypes.LAYOUT_FULL:
        return FullLayout;
      default:
        return VerticalLayout;
    }
  };

  const Navigator = useNavigate();
  
  const setNavigate = useAuth(state => state.setNavigate);
  useEffect(() => {
    setNavigate(Navigator);
  }, [Navigator, setNavigate]);

  return useRoutes([
    //#region Global
    {
      path: '/',
      element: <DefaultLayout />,
      children: [
        {
          index: true,
          element: <Navigate to="/escritorio" replace />,
        },
        ...AuthRoutes,
        ...SystemRoutes
      ],
    },

    {
      path: '/',
      element: <PrivateRouteAuthenticated component={getLayout()} />,
      children: UserProfile,
    },

    //#region Empregado
    {
      path: '/',
      element: <PrivateRouteEmployee component={getLayout()} />,
      children: [
        {
          index: true,
          element: <Navigate to="/escritorio" replace />,
        },
        ...ScreenRoutes.Office,
      ],
    },

    //#region TaxClaimant
    {
      path: '/txclmt',
      element: <PrivateRouteTaxClaimant component={getLayout()} />,
      children: [
        {
          index: true,
          element: <Navigate to="/txclmt/documents" replace />,
        },
        ...ScreenRoutes.TaxClaimant,
      ],
    },

    //#region Client (Portal do Cliente)
    {
      path: '/cliente',
      element: <PrivateRouteClient component={getLayout()} />,
      children: [
        {
          index: true,
          element: <Navigate to="/cliente/documents" replace />,
        },
        ...ScreenRoutes.Client,
      ],
    },

    //#region Admin
    {
      path: '/manager',
      element: <PrivateRouteAdmin component={getLayout()} />,
      children: [
        {
          index: true,
          element: <Navigate to="/manager/escritorios" replace />,
        },
        ...AdminRoutes,
      ],
    },

    //#region NotFound
    {
      path: '*',
      element: <Navigate to="/error-404" replace />,
    },
  ]);
};

export { AllRoutes };
